<template>

</template>

<script>
import CONST from "@/utils/Constants";
import GAMixins from "../mixins/GAMixins";


export default {
  name: "PLPComponent",
  data() {
    return {
      searchPageData: {},
      collectionMap: {}
    }
  },
  props: [
    'categoryPath',
  ],
  mixins: [
    GAMixins
  ],
  methods: {
    printGoogleAnalytics() {
      ACC.log.group("print_view_item_list")

      if (this.searchPageData.results.length > 0) {
        const entry = {
          event: 'view_item_list',
          ecommerce: {
            commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
            items: this.getProductSearch(this.searchPageData.results, null, this.collectionMap, this.categoryPath)
          }
        }
        this.pushEvent(entry);
        console.groupEnd();
      }
    },
    printReachedPDP(product, categoryCode, positionIndex, categoryPathResolverEn) {
      ACC.log.group("printReachedPDP")
      ACC.log.info({'product': product}, {'categoryCode': categoryCode}, {'positionIndex': positionIndex}, {'categoryPathResolverEn': categoryPathResolverEn})
      const entry = {
        event: 'select_item',
        ecommerce: {
          commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
          items: [
            this.buildProductGAObject5(product, null, ACC.config.flagVistaDivision, null, null, categoryCode, positionIndex, this.collectionMap)
          ]
        }
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
  },
  created() {
    //INIT PRODUCT DATA
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PLP.INIT, ({plpProducts, collectionMap}) => {
      this.searchPageData = plpProducts;
      this.collectionMap = collectionMap;
      this.printGoogleAnalytics();
    });

    // BIND FROM PLP TO PDP EVENT
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PLP.FROM_PLP_TO_PDP, ({product, categoryCode, index, categoryPathResolverEn}) => {
      this.printReachedPDP(product, categoryCode, index, categoryPathResolverEn);
    });
  }


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/PLPComponent.vue